<a href="/"><img class="projectzen-logo" src="/assets/projectzen_logo.jpg" alt="projectzen_logo.jpg" /></a>
<h1 class="main-header">Do More, Better.</h1>
<h2 class="subheader">
  ProjectZen is an elegant, flexible tool for agile teams.
</h2>
<form class="container log-in-form" (keydown.enter)="onEnterPress()">
  <div class="text-inputs">
    <div class="container label text-box-label-container">
      <label class="label text-box-label">Email<br /></label>
    </div>
    <input class="input text-input-field" id="txtEmail" type="email" name="email" required spellcheck="false"
      autocorrect="off" maxlength="75" autocapitalize="off" />
    <div class="container label text-box-label-container">
      <label class="label text-box-label">Password<br /></label>
    </div>
    <input id="txtPassword" class="input text-input-field" type="password" name="password" required />
  </div>
  <button type="button" class="login-button" mat-fab extended (click)="logInUser('txtEmail', 'txtPassword')">
    Log In
  </button>
</form>
<div class="container forgot-password-link-container">
  <a class="forgot-password-link" href="accounts/password-reset">Forgot password?</a>
</div>
<app-page-footer></app-page-footer>